import styled, { css } from "styled-components";
import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
  IconButton
} from "@material-ui/core";

import { Scrollbar } from "../../common/Scrollbar";

export const Dialog = styled(MuiDialog)`
	.MuiPaper-root {
		background: ${props => props.theme.palette.primary.main};
		box-shadow: none;
		width: ${props => props.theme.widthRatio*1297}px;
		max-width: unset;
		min-height: ${props => props.theme.heightRatio*800}px;
		margin-top: ${props => props.theme.heightRatio*120}px;
		padding: ${props => props.theme.heightRatio*33}px
		         ${props => props.theme.widthRatio*58}px
		         ${props => props.theme.heightRatio*22}px
		         ${props => props.theme.widthRatio*58}px;
		align-items: center;
		border-radius: 10px;
		position: relative;
		margin-left: ${props => props.theme.widthRatio * 320}px;
		
    ${props => props.theme.name === 'dark' && css`
      border: 1px solid ${props => props.theme.palette.secondary.main};
    `}
  
    ${props => props.theme.name === 'light' && css`
      box-shadow: 0 2px 32px 4px rgba(0,0,0,0.2);
    `}
	}
`;

export const DialogContent = styled(MuiDialogContent)`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: 0 !important;
	color: ${props => props.theme.palette.third[100]}
	text-align: center;
	
	h4 {
		font: ${props => props.theme.widthRatio*30}px/${props => props.theme.heightRatio*40}px SFProRounded-Bold;
		margin: 0 0 ${props => props.theme.widthRatio*20}px;
		color: ${props => props.theme.palette.third[100]};
	}
	
	p {
	  font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
	  margin: 0;
	  text-align: justify;
	}
	
  .content {
    display: flex;
    justify-content: space-between;
    
    .arrow-next {
      padding: ${props => props.theme.heightRatio * 164}px
               ${props => props.theme.heightRatio * 18}px
               0
               ${props => props.theme.heightRatio * 18}px;
               
       img {
        width: 100%;
       }
    }
    
    .instruction {
      width: ${props => props.theme.widthRatio * 337}px;
      display: flex;
      flex-flow: column;
      align-items: center;
      
      &:last-child {
        margin-right: 0;
      }
      
      h2 {
        font: ${props => props.theme.widthRatio * 30}px/${props => props.theme.heightRatio * 48}px SFProRounded-Bold;
        color: ${props => props.theme.palette.third[100]};
        margin-top: 0;
        margin-bottom: ${props => props.theme.heightRatio * 41}px;
      }
        
        .img-wrapper {
          
          margin-bottom: ${props => props.theme.heightRatio * 50}px;
          display: flex;
          align-items: center;
          justify-content: center;
          
          img {
            width: ${props => props.theme.widthRatio*333}px;
          }
        }
        
        .text-wrapper {
          
          h6 {
            width: 100%;
            font: ${props => props.theme.widthRatio * 26}px/${props => props.theme.heightRatio * 35}px SFProRounded-Bold;
            color: ${props => props.theme.palette.third[100]};
            margin-top: 0;
            margin-bottom: ${props => props.theme.heightRatio * 15}px;
            text-align: center;
          }
          
          ul {
            min-height: ${props => props.theme.heightRatio*180}px;
            margin: 0;
            padding-left: 25px;
            
            li {
              font: ${props => props.theme.widthRatio * 19}px/${props => props.theme.heightRatio * 26}px SFProRounded-Regular;
              color: ${props => props.theme.palette.third[100]};
              margin: 0;
              text-align: justify;
            
              span {
                color: ${props => props.theme.palette.secondary.main};
                text-decoration: underline;
              }
            }
          }
          
          p  {
            font: ${props => props.theme.widthRatio * 19}px/${props => props.theme.heightRatio * 26}px SFProRounded-Regular;
            color: ${props => props.theme.palette.third[100]};
            margin: 0;
            text-align: justify;
          
            span {
              color: ${props => props.theme.palette.secondary.main};
              text-decoration: underline;
            }
          }
          
          ${props => props.theme.name === 'dark' && css`
						a {
							color: ${props => props.theme.palette.secondary.main};
						}
					`}
        
          ${props => props.theme.name === 'light' && css`
						a {
							font: ${props => props.theme.widthRatio * 19}px/${props => props.theme.heightRatio * 26}px SFProRounded-Bold;
							color: ${props => props.theme.palette.third[100]};
						}
					`}
          
          a {
            text-decoration: none;
            
            &.support-link {
              text-decoration: underline;
            }
          }
        }
      }
    }
`;

export const CloseButton = styled(IconButton)`
  padding: 0;
  width: ${props => props.theme.widthRatio * 40}px;
  height: ${props => props.theme.widthRatio * 40}px;
  position: absolute;
  right: ${props => props.theme.widthRatio * 10}px;
  top: ${props => props.theme.widthRatio * 13}px;
  cursor: pointer;
  font: ${props => props.theme.widthRatio*26}px/${props => props.theme.heightRatio*35}px SFProRounded-Bold;
  color: ${props => props.theme.palette.third[100]};
`;

export const ScrollbarWrapper = styled(Scrollbar)`
  padding-right: ${props => props.theme.widthRatio*30}px;
`;

export const ModeSelect = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: ${props => props.theme.heightRatio*47}px;
	
`;

export const SelectButton = styled(MuiButton)`
	border-radius: ${props => props.theme.widthRatio * 5}px;
	background-color: ${props => props.theme.name === 'dark' ? props.theme.palette.primary[850] : '#DEDEDE'};
	box-shadow: none;
	font: ${props => props.theme.widthRatio*21}px/${props => props.theme.heightRatio*28}px SFProRounded-Regular;
	color: ${props => props.theme.palette.third[100]};
	min-width: ${props => props.theme.widthRatio * 185}px;
	height: ${props => props.theme.widthRatio * 46}px;
	
	${props => !!props.active && css`
		background-color: ${props.theme.palette.secondary.main};
		color: #1F1F1F;
		
		&:hover {
			background-color: ${props.theme.palette.secondary[50]};
		}
	`}
	
	&:first-child {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	
	&:last-child {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
`;
